var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburguerButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "HamburguerButton") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 8.85c0 .477-.393.87-.87.87H.87A.875.875 0 010 8.85c0-.477.393-.87.87-.87h11.26c.481 0 .87.39.87.87zm0-4c0 .477-.393.87-.87.87H.87A.875.875 0 010 4.85c0-.477.393-.87.87-.87h11.26c.481 0 .87.39.87.87zm0-4c0 .477-.393.87-.87.87H.87A.875.875 0 010 .85c0-.477.393-.87.87-.87h11.26c.481 0 .87.39.87.87z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburguerButton);
export default __webpack_public_path__ + "static/media/HamburguerButton.42a1dba060732bd7902dbba211ea2c70.svg";
export { ForwardRef as ReactComponent };